// MENSAJES
export const MSJ_NO_HAY_CALLES = 'No se ha encontrado ninguna calle';
export const MSJ_INGRESE_NUMERO_DOCUMENTO = 'Ingrese su número de documento';
export const MSJ_INGRESE_CONTRASENA_ACTUAL = 'Ingrese su contraseña actual';
export const MSJ_INGRESE_NUEVA_CONTRASENA = 'Ingrese su nueva contraseña';
export const MSJ_REPITA_NUEVA_CONTRASENA = 'Repita su nueva contraseña';
export const MSJ_CONTRASENA_ENTRE_6_AND_12_CARACTERES = 'Contraseña debe tener entre 6 y 12 caracteres';
export const MSJ_CONTRASENAS_NO_COINCIDEN = 'Las contraseñas no coinciden';
export const MSJ_SE_HA_CAMBIADO_CONTRASEÑA = 'Se ha cambiado la contraseña';
// PLACEHOLDER
export const PCHR_INGRESAR_DNI = 'Ingrese su dni';
export const PCHR_REPETIR_CONTRASENA = 'Repita nueva contraseña';
// LABEL
export const LABEL_CONTRASENA_ACTUAL = 'Contraseña actual';
export const LABEL_NUEVA_CONTRASENA = 'Nueva contraseña';
export const LABEL_REPETIR_CONTRASENA ='Repetir contraseña';
export const LABEL_CAMBIAR_CONTRASENA = 'Cambiar Contraseña';